import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt';

import { format, differenceInCalendarMonths } from '../utils';
import Month from './Month';
import DefinedRanges from './DefinedRanges';
import { DateRange, DefinedRange, Setter } from '../types';
import { NavigationAction } from '../enums';
import { MARKERS } from '..';

interface MenuProps {
  dateRange: DateRange;
  ranges: DefinedRange[];
  minDate: Date;
  maxDate: Date;
  firstMonth: Date;
  secondMonth: Date;
  classes?: any;
  setFirstMonth: Setter<Date>;
  setSecondMonth: Setter<Date>;
  setDateRange: Setter<DateRange>;
  helpers: {
    inHoverRange: (day: Date) => boolean;
  };
  handlers: {
    onDayClick: (day: Date) => void;
    onDayHover: (day: Date) => void;
    onMonthNavigate: (marker: symbol, action: NavigationAction) => void;
  };
}

const stylesBuilder = () => ({
  header: {
    padding: '20px 70px'
  },
  headerItem: {
    flex: 1,
    textAlign: 'center'
  },
  divider: {
    borderLeft: `1px solid gray`,
    marginBottom: '20px'
  }
});

function Menu(props: MenuProps) {
  const {
    ranges,
    dateRange,
    minDate,
    maxDate,
    firstMonth,
    setFirstMonth,
    secondMonth,
    setSecondMonth,
    setDateRange,
    helpers,
    handlers
  } = props;

  const styles = stylesBuilder();

  const { startDate, endDate } = dateRange;
  const canNavigateCloser =
    differenceInCalendarMonths(secondMonth, firstMonth) >= 2;
  const commonProps = { dateRange, minDate, maxDate, helpers, handlers };
  return (
    <Paper elevation={5} sx={{ maxHeight: '500px', maxWidth: '750px' }} square>
      <Grid direction="row" wrap="nowrap" container>
        <Grid>
          <Grid alignItems="center" sx={{ ...styles?.header }} container>
            <Grid sx={{ ...styles?.headerItem }} item>
              <Typography variant="subtitle1">
                {startDate ? format(startDate, 'DD/MM/YYYY') : 'Fecha inicio'}
              </Typography>
            </Grid>
            <Grid sx={{ ...styles?.headerItem }} item>
              <ArrowRightAlt color="action" />
            </Grid>
            <Grid sx={{ ...styles?.headerItem }} item>
              <Typography variant="subtitle1">
                {endDate ? format(endDate, 'DD/MM/YYYY') : 'Fecha fin'}
              </Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid direction="row" justifyContent="center" wrap="nowrap" container>
            <Month
              {...commonProps}
              marker={MARKERS.FIRST_MONTH}
              navState={[true, canNavigateCloser]}
              setValue={setFirstMonth}
              value={firstMonth}
            />
            <Box sx={{ ...styles?.divider }} />
            <Month
              {...commonProps}
              marker={MARKERS.SECOND_MONTH}
              navState={[canNavigateCloser, true]}
              setValue={setSecondMonth}
              value={secondMonth}
            />
          </Grid>
        </Grid>
        <Box sx={{ ...styles?.divider }} />
        <Grid>
          <DefinedRanges
            ranges={ranges}
            selectedRange={dateRange}
            setRange={setDateRange}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default Menu;
